import { IModel } from '@/@types/models/model';

const UpitnikTrazi: IModel = {
  title: 'Upitnik trazi',
  apiPath: 'groblja/upitnik-trazi',
  forms: {
    default: {
      fields: ['groblje_id', 'polje', 'red', 'broj'],
    },
  },
  listViews: {
    default: {
      fields: [],
    },
  },
  fields: [
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:upitnik.trazi.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/upitnik-trazi/groblja',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
    },
    {
      title: 'polje',
      source: 'polje',
      ttoken: 'groblja:upitnik.polje',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'red',
      source: 'red',
      ttoken: 'groblja:upitnik.red',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
    },
    {
      title: 'broj',
      source: 'broj',
      ttoken: 'groblja:upitnik.broj',
      type: 'text',
      validation: {
        required: true,
        maxLength: 50,
      },
    },
  ],
};

export default UpitnikTrazi;
